import React from 'react';
import styled from 'styled-components';

const StyledIcon = styled.i`
  font-size: 32px;
  color: ${(props) => props.theme.orderStatusIconColor};

  @media (max-width: 480px) {
    font-size: 32px;
  }
`;

const Icon = (props) => {
  return <StyledIcon {...props} />;
};

export default Icon;
